jQuery( document ).ready(function() {
    let swiper = new Swiper(".swiper.post-slider", {
        slidesPerView: "auto",
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
});
